import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GetYucangooRatingPipe } from "app_locobook/shared/yucangoo/get-yucangoo-rating.pipe";

@NgModule({
  declarations: [
      GetYucangooRatingPipe,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
      GetYucangooRatingPipe,
  ],
  providers: [
    GetYucangooRatingPipe,
  ]
})
export class YucangooModule { }
